import roundIconStyle from '../GameInfoMobile/components/RoundIconsWrapper/RoundIconsWrapper.scss';
import portraitGameInfoStyle from '../GameInfoMobile/components/PortraitGameInfoMobile/PortraitGameInfoMobile.scss';
import { ANIMATE_ON_OPEN, PORTRAIT_BACKGROUND, ROUND_ICONS } from './constants';
import { keys, reduce } from 'ramda';
import { AnimationItems } from './types';

// This config is needed to add classes to particular elements
export const ANIMATION_ITEMS_CONFIG: AnimationItems = {
    [ROUND_ICONS]: {
        classNameKeys: ['icon'],
        style: roundIconStyle,
        animationTypes: [ANIMATE_ON_OPEN]
    },
    [PORTRAIT_BACKGROUND]: {
        classNameKeys: ['fakeBg'],
        style: portraitGameInfoStyle,
        animationTypes: [ANIMATE_ON_OPEN]
    }
};

export const ANIMATION_ITEMS_LIST = keys(ANIMATION_ITEMS_CONFIG);

export const ANIMATION_CLASSES_MAP: { [key: string]: string[] } = ANIMATION_ITEMS_LIST.reduce((acc, key) => ({
    ...acc,
    [key]: ANIMATION_ITEMS_CONFIG[key].classNameKeys
}), {});

const ALL_ANIMATION_TYPES = reduce((acc, key) =>
    [...new Set([...acc, ...ANIMATION_ITEMS_CONFIG[key].animationTypes])],
[] as string[], ANIMATION_ITEMS_LIST);

export const ANIMATION_CLASSES_STATE_CONFIG = reduce((classesConfig, animationType) => ({
    ...classesConfig,
    [animationType]: reduce((itemsConfig, itemKey) => ({
        ...itemsConfig,
        ...(
            ANIMATION_ITEMS_CONFIG[itemKey].animationTypes.includes(animationType)
            && { [itemKey]: [] }
        )
    }),
        {},
        ANIMATION_ITEMS_LIST
    )
}),
    {},
    ALL_ANIMATION_TYPES
);
